export default function DSA_Certificate() {
  return <div>DSA_Certificate Component</div>;
}
